import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';
import { activeNetworkSelector } from '../../../redux/selectors';

export const MovementContactRenderer = ({ data }) => {
  const { colors } = useTheme();
  const activeNetwork = useSelector(activeNetworkSelector);
  const history = useHistory();
  const movement = data?.original;

  if (movement?.isSkeleton) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={48}
        viewBox="0 0 400 48"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
        style={{ paddingLeft: '16px' }}
      >
        <circle cx="20" cy="24" r="12" />
        <rect x="40" y="16" rx="3" ry="3" width="120" height="12" />
      </ContentLoader>
    );
  }

  if (!movement?.contact) {
    return '';
  }

  const { contact } = movement;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    history.push(`/networks/${activeNetwork.slug}/contacts/${contact.id}`);
  };

  return (
    <Flex
      p="8px"
      pl="16px"
      alignItems="center"
      onClick={handleClick}
      sx={{
        height: '100%',
        gap: '8px',
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
          bg: 'neutral.20',
        },
      }}
    >
      <Box width="24px" height="24px" flex="0 0 auto">
        <ProfilePicture
          sx={{
            minWidth: '24px',
            minHeight: '24px',
          }}
          imageUrl={contact.profilePicUrl || ''}
          name={contact.fullName || 'Getro'}
        />
      </Box>
      <Text
        fontSize="14px"
        fontWeight="medium"
        color="text.main"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          flex: 1,
        }}
      >
        {contact.fullName}
      </Text>
    </Flex>
  );
};

MovementContactRenderer.propTypes = {
  data: PropTypes.object,
};

MovementContactRenderer.defaultProps = {
  data: {},
};
